import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.css';

type PurchaseModeToggleProps = {
  isCheckoutLink: boolean;
  onChange: (isCheckoutLink: boolean) => void;
};

export const PurchaseModeToggle = ({
  isCheckoutLink,
  onChange,
}: PurchaseModeToggleProps) => (
  <div className={styles.toggle}>
    <button
      type="button"
      className={classNames(
        styles.toggleOption,
        isCheckoutLink && styles.toggleOptionActive
      )}
      onClick={() => onChange(true)}
    >
      <span className={styles.toggleLabel}>Checkout-Link</span>
    </button>
    <button
      type="button"
      className={classNames(
        styles.toggleOption,
        !isCheckoutLink && styles.toggleOptionActive
      )}
      onClick={() => onChange(false)}
    >
      <span className={styles.toggleLabel}>Direct Checkout</span>
    </button>
  </div>
);
